import { getActiveUser } from "@noom/hive-auth";
import {
  EligibleOffersProto,
  GetEligibleOffersResponseProto,
} from "@noom/noom-contracts/noom_contracts/offers/buyflow/api/eligible_offers_service";
import { getAuthorizationHeader } from "src/api/utils";
import { appConfig } from "src/config";

export async function queryBuyflowEligibleOffers(): Promise<
  EligibleOffersProto[] | null
> {
  const accessCode = getActiveUser()?.accessCode;

  const response = await fetch(
    `${appConfig.OFFERS_API_URL}/offers/v1/user/${accessCode}/getEligibleOffers`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...getAuthorizationHeader(),
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to get user details: ${response.status}`);
  }
  const result: GetEligibleOffersResponseProto = await response.json();
  return result.eligibleOffers;
}
